export const INIT_MEDIA_STREAMS = 'events/INIT_MEDIA_STREAMS';

/**
 * @return {{type: string}}
 */
export const initMediaStreams = () => ({ type: INIT_MEDIA_STREAMS });
